import { useEffect, useRef, useState } from 'react'
import { GridCellProps } from '@progress/kendo-react-grid'
import { NumbersAndDotOnlyPattern } from 'utils/formValidation'

import { RateFormData } from '../hooks/useCurrencyMarkups'

import styles from './../CurrencyMarkups.module.scss'

interface EditableHighlightCellProps extends GridCellProps {
  onCellClick?: (dataItem: RateFormData, field: string, finalValue?: string) => void
}

export const EditableHighlightCell = (props: EditableHighlightCellProps) => {
  const { field, dataItem, onCellClick } = props
  const value = dataItem[field as keyof typeof dataItem]
  const errorMessage = dataItem.errors?.[field as keyof typeof dataItem.errors]

  const isEditing = dataItem.inEdit === field
  const inputRef = useRef<HTMLInputElement>(null)
  const [localValue, setLocalValue] = useState(String(value))

  useEffect(() => {
    if (isEditing) {
      setLocalValue(String(value))
      setTimeout(() => inputRef.current?.focus(), 0)
    }
  }, [isEditing])

  if (!isEditing) {
    return (
      <td
        className={errorMessage ? styles.invalidCell : ''}
        onClick={() => onCellClick?.(dataItem, field as string)}
        style={{ cursor: 'pointer' }}
      >
        {value}
      </td>
    )
  }

  return (
    <td className={errorMessage ? styles.invalidCell : ''}>
      <input
        ref={inputRef}
        type='text'
        value={localValue}
        onChange={(e) => {
          const newValue = e.target.value.replace(NumbersAndDotOnlyPattern, '')
          setLocalValue(newValue)
        }}
        onBlur={() => {
          onCellClick?.(dataItem, '', localValue)
        }}
      />
      {errorMessage && <div className={styles.errorLabel}>{errorMessage}</div>}
    </td>
  )
}
